"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPONENTS_CONFIG = exports.CROSS_COMPONENTS_NAME = void 0;
exports.CROSS_COMPONENTS_NAME = 'cross-components';
exports.COMPONENTS_CONFIG = 'componentsConfig';
//# sourceMappingURL=constants.js.map